<div class="flex flex-col gap-3">
  @for (position of state.positions(); track position.id) {
    <hawk-shipping-position-card [pos]="position">
      @switch (position.id) {
        @case ("station") {
          <hawk-shipping-station-position />
        }

        @case ("method") {
          <div class="flex gap-x-6 gap-y-2 flex-wrap">
            <div class="flex gap-1 flex-wrap">
              @for (method of state.visibleShipmentMethods(); track method.value) {
                <button
                  type="button"
                  class="bm-btn bm-btn-sm"
                  [class.bm-btn-primary]="state.shipmentMethod() === method.value"
                  [disabled]="state.readOnly()"
                  (click)="state.setShipmentMethod(method.value)"
                >
                  <fa-icon [icon]="method.icon" class="mr-1" />{{ method.label }}
                </button>
              }
            </div>

            @if (state.shipmentMethod() === "parcel") {
              <div class="flex gap-1 flex-wrap">
                @for (speed of packageSpeeds; track speed.value) {
                  <button
                    type="button"
                    class="bm-btn bm-btn-sm"
                    [class.bm-btn-primary]="state.packageSpeed() === speed.value"
                    [disabled]="state.readOnly()"
                    (click)="state.packageSpeed.set(speed.value)"
                  >
                    <fa-icon [icon]="speed.icon" class="mr-1" />{{ speed.label }}
                  </button>
                }
              </div>
            }
          </div>
        }

        @case ("technician") {
          <hawk-shipping-technician-position />
        }

        @case ("pm_code") {
          <input
            class="bm-input w-full"
            type="text"
            placeholder="z.B. PM-692636"
            [ngModel]="state.pmCode()"
            [disabled]="state.readOnly()"
            (ngModelChange)="state.pmCode.set($event)"
          />
        }

        @case ("disposition") {
          <div class="flex gap-1 flex-wrap">
            <button
              type="button"
              class="bm-btn bm-btn-sm"
              [class.bm-btn-primary]="state.articleDisposition() === 'technician_transfer'"
              [disabled]="state.readOnly()"
              (click)="state.articleDisposition.set('technician_transfer')"
            >
              Auf Techniker umbuchen
            </button>
            <button
              type="button"
              class="bm-btn bm-btn-sm"
              [class.bm-btn-primary]="state.articleDisposition() === 'consumed'"
              [disabled]="state.readOnly()"
              (click)="state.articleDisposition.set('consumed')"
            >
              Verbraucht (installiert)
            </button>
          </div>
          @if (state.articleDisposition() === "technician_transfer") {
            <div class="mt-3 border-t border-base-200 pt-2">
              <hawk-shipping-technician-position />
            </div>
          }
        }

        @case ("ship_address") {
          <select
            class="bm-select w-full"
            [ngModel]="state.technicianShipTarget()"
            [disabled]="state.readOnly()"
            (ngModelChange)="state.technicianShipTarget.set($event)"
          >
            <option value="warehouse">Lageradresse (Umbuchungslager)</option>
            <option value="private">Privatadresse des Technikers</option>
          </select>
        }

        @case ("customer") {
          <hawk-shipping-customer-position />
        }
      }
    </hawk-shipping-position-card>
  }
</div>
